var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkIntraverseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 163,
    viewBox: "0 0 240 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coloured_Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.725 154.959L231.642 130.764L234.662 123.149L204.775 112.832L196.861 112.523L153.719 125.88L153.725 154.959Z",
    fill: "url(#paint0_linear_13407_17046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.725 154.959L151.726 157.674L154.318 156.869L232.235 132.674L233.148 132.39L233.501 131.501L236.521 123.887L237.293 121.942L235.315 121.259L205.427 110.941L205.148 110.845L204.853 110.833L196.939 110.525L196.597 110.512L196.269 110.613L153.127 123.969L151.718 124.405L151.719 125.88L151.725 154.959Z",
    stroke: "#1B1B23",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.703 154.65L8.78616 130.455L5.76562 122.841L35.6532 112.523H43.567L86.7122 125.88L86.703 154.65Z",
    fill: "url(#paint1_linear_13407_17046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1099 156.561L88.7021 157.365L88.703 154.651L88.7122 125.88L88.7127 124.405L87.3037 123.969L44.1585 110.613L43.8695 110.523H43.567H35.6532H35.3177L35.0006 110.633L5.11301 120.95L3.13495 121.633L3.90655 123.578L6.92708 131.193L7.27972 132.082L8.19305 132.365L86.1099 156.561Z",
    stroke: "#1B1B23",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.593 4.35742L96.4219 10.2288V158.975H144.349V10.2288L138.179 4.35742L102.593 4.35742Z",
    fill: "url(#paint2_linear_13407_17046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.593 2.35742H101.793L101.214 2.90851L95.0432 8.77989L94.4219 9.37111V10.2288V158.975V160.975H96.4219H144.349H146.349V158.975V10.2288V9.37111L145.728 8.77989L139.557 2.90851L138.978 2.35742H138.179L102.593 2.35742Z",
    stroke: "#1B1B23",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13407_17046",
    x1: 157.873,
    y1: 152.781,
    x2: 191.077,
    y2: 89.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13407_17046",
    x1: 9.92005,
    y1: 152.488,
    x2: 42.745,
    y2: 89.4157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13407_17046",
    x1: 98.8817,
    y1: 151.04,
    x2: 182.08,
    y2: 125.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0153F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD42CE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkIntraverseLogo);
export default __webpack_public_path__ + "static/media/pink_intraverse_logo.ae30ecc3ef76f112361fe6ac4c39548d.svg";
export { ForwardRef as ReactComponent };